import Vue from 'vue';
import Vuetify from 'vuetify/lib';

// To use Material colors - colors.blue.lighten3
// https://vuetifyjs.com/en/styles/colors/#sass-color-pack
// import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#2196f3',
        secondary: '#03a9f4',
        accent: '#00bcd4',
        error: '#f44336',
        warning: '#ffc107',
        info: '#009688',
        success: '#4caf50',
      },
    },
  },
});
